{"heading":"Autopilot","enabledCheckboxLabel":"Enabled","userEditibleCheckboxLabel":"User can edit","daysEnabledHeading":"Days enabled"}